import type VueRouter from 'vue-router';
import type { Route } from 'vue-router';

export function navigateToWrite(
  router: VueRouter,
  route: Route,
  investCompanyUid: string,
) {
  const { menuUid } = route.params;

  router.push({
    name: 'Write',
    params: {
      menuUid,
    },
    query: {
      investCompanyUid,
    },
  });
}
